import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.common.DocumentPreviewPanel', {
    previewName: 'Generating preview {br} {documentName}',
    pdfNotSupportedInBrowser: 'Your browser does not support PDF preview',
    cannotGenerate: 'Preview for this file couldn`t be generated',
    downloadBtnInfo: 'Download',
});
